export default __webpack_public_path__ + "static/media/energisingchocolate@3x.4359e197.jpg";